import { createFileRoute } from '@tanstack/react-router'

import { GroupWorkspacePage } from '@/features/group/components/GroupWorkspacePage'
import { loadGroupWorkspace } from '@/features/group/workspaces'

/** Profil Toko: the existing per-group store editor, inside the Store Settings shell. */
export const Route = createFileRoute('/_authed/settings/store')({
  loader: ({ context }) => loadGroupWorkspace(context.queryClient),
  component: () => <GroupWorkspacePage mode="settings" embedded />,
})
